import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {
    AuthActions,
    AuthStorageService,
    OCC_USER_ID_CURRENT,
    StateWithClientAuth,
    UserIdService,
} from '@spartacus/core';

export interface AimoOAuthTokenResponse {
    access_token: string;
    token_type?: string;
    expires_in?: number;
    refresh_token?: string;
    scope?: string;
}

/**
 * Writes OAuth token responses into Spartacus AuthStorage in the format expected by OCC interceptors.
 */
@Injectable({
    providedIn: 'root',
})
export class AimoTokenStorageService {
    constructor(
        protected store: Store<StateWithClientAuth>,
        protected authStorageService: AuthStorageService,
        protected userIdService: UserIdService,
    ) {
    }

    activateSession(token: AimoOAuthTokenResponse): void {
        const now = Date.now();
        this.authStorageService.setItem('access_token', token.access_token);
        this.authStorageService.setItem('access_token_stored_at', '' + now);
        if (token.expires_in != null) {
            this.authStorageService.setItem('expires_at', '' + (now + Number(token.expires_in) * 1000));
        } else {
            this.authStorageService.removeItem('expires_at');
        }
        if (token.refresh_token) {
            this.authStorageService.setItem('refresh_token', token.refresh_token);
        } else {
            this.authStorageService.removeItem('refresh_token');
        }
        if (token.token_type) {
            this.authStorageService.setItem('token_type', token.token_type);
        }
        this.userIdService.setUserId(OCC_USER_ID_CURRENT);
        this.store.dispatch(new AuthActions.Login());
    }
}
